<div class="row margin0" *ngIf="case || alert">
  <div class="col-6" data-tour="alerta.origen">
    <div
      class="divData"
      *ngIf="
        case ? case?.additionalInformation?.tipo_registro : alert?.tipo_registro
      "
    >
      <p class="dataTitle">Tipo de registro</p>
      <p class="dataInfo">
        {{
          case
            ? case?.additionalInformation.tipo_registro
            : alert?.tipo_registro
        }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case ? case?.alert?.uidTransaction : alert?.uidTransaction"
    >
      <p class="dataTitle">VU UID</p>
      <p class="dataInfo">
        {{ case ? case?.alert?.uidTransaction : alert?.uidTransaction }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case ? case?.additionalInformation?.oficina : alert?.oficina"
    >
      <p class="dataTitle">Descripción de la alerta</p>
      <p class="dataInfo">
        {{ case ? case?.additionalInformation.oficina : alert?.oficina }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="
        case ? case?.additionalInformation?.instrumento : alert?.instrumento
      "
    >
      <p class="dataTitle">Datos del instrumento financiero</p>
      <p class="dataInfo">
        {{
          case ? case?.additionalInformation.instrumento : alert?.instrumento
        }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="
        case
          ? case?.additionalInformation?.instrumento_destino
          : alert?.instrumento_destino
      "
    >
      <p class="dataTitle">Datos instrumento destino</p>
      <p class="dataInfo">
        {{
          case
            ? case?.additionalInformation.instrumento_destino
            : alert?.instrumento_destino
        }}
      </p>
    </div>
    <div *ngIf="case || alert" class="divData">
      <p class="dataTitle">Alerta</p>
      <p class="dataInfo">{{ case?.alert?.gai || alert?.gai }}</p>
    </div>
    <div class="divData" *ngIf="case?.commentReview">
      <p class="dataTitle">Comentario aprobación</p>
      <p class="dataInfo">
        {{ case?.commentReview.substring(0, 40) }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case?.commentRejectAssignament && !case?.assigned"
    >
      <p class="dataTitle">Comentario rechazo asignación</p>
      <p class="dataInfo">
        {{ case?.commentRejectAssignament }}
      </p>
    </div>
    <div class="divData" *ngIf="alert?.aditionalInformation?.observacion">
      <p class="dataTitle">Observación especialista</p>
      <p class="dataInfo">
        {{ alert?.aditionalInformation?.observacion }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case ? case?.additionalInformation?.category : alert?.category"
    >
      <p class="dataTitle">Categoría</p>
      <p class="dataInfo">
        {{ case ? case?.additionalInformation.category : alert?.category }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case ? case?.additionalInformation?.subType : alert?.subType"
    >
      <p class="dataTitle">SubTipo</p>
      <p class="dataInfo">
        {{ case ? case?.additionalInformation.subType : alert?.subType }}
      </p>
    </div>
    <div class="divData">
      <p class="dataTitle">Analista responsable</p>
      <p class="dataInfo">
        {{
          case?.assigned?.fullname || alert?.assigned?.fullname || "Sin asignar"
        }}
      </p>
    </div>
  </div>
  <div class="col-6" data-tour="alerta.gestion">
    <div class="divData" *ngIf="case ? case?.status : alert?.status">
      <p class="dataTitle">Estado del alerta</p>
      <p class="dataInfo">
        {{ case ? status[case?.status] : status[alert?.status] }}
      </p>
    </div>
    <div class="divData" *ngIf="alert?.createdAt">
      <p class="dataTitle">Fecha de creación</p>
      <p class="dataInfo">
        {{ alert?.createdAt | date : "d/M/yy, h:mm:ss a" }}
      </p>
    </div>
    <div class="divData" *ngIf="case?.toAssignedAt">
      <p class="dataTitle">Fecha de asignación</p>
      <p class="dataInfo">
        {{ case?.toAssignedAt | date : "d/M/yy, h:mm:ss a" }}
      </p>
    </div>
    <div class="divData" *ngIf="case?.toFinalizeAt">
      <p class="dataTitle">Fecha de finalización</p>
      <p class="dataInfo">
        {{ case?.toFinalizeAt | date : "d/M/yy, h:mm:ss a" }}
      </p>
    </div>
    <div class="divData" *ngIf="!alert">
      <p class="dataTitle">Fecha de creación</p>
      <p class="dataInfo">
        {{ case?.alert?.createdAt | date : "d/M/yy, h:mm:ss a" }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case ? case?.additionalInformation?.canal : alert?.canal"
    >
      <p class="dataTitle">Canal</p>
      <p class="dataInfo">
        {{ case ? case?.additionalInformation.canal : alert?.canal }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="
        case
          ? case?.alert?.userTipify?.fullname || case?.creator?.fullname
          : alert?.userTipify?.fullname || alert?.creator?.fullname
      "
    >
      <p class="dataTitle">Gerente responsable</p>
      <p class="dataInfo">
        {{
          case
            ? case?.alert?.userTipify?.fullname || case?.creator?.fullname
            : alert?.userTipify?.fullname || alert?.creator?.fullname
        }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="
        case ? case?.additionalInformation?.monto_salio : alert?.monto_salio
      "
    >
      <p class="dataTitle">Monto de la transacción</p>
      <p class="dataInfo">
        {{
          (case ? case?.additionalInformation.monto_salio : alert?.monto_salio)
            | number : "1.2-2" : "es"
        }}
      </p>
    </div>
    <div class="divData" *ngIf="case?.alert?.status && case?.assigned">
      <p class="dataTitle">Decisión</p>
      <p class="dataInfo">
        {{ statusAlert[case?.additionalInformation?.status] }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case ? case?.additionalInformation?.type : alert?.type"
    >
      <p class="dataTitle">Tipo</p>
      <p class="dataInfo">
        {{ case ? case?.additionalInformation.type : alert?.type }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case ? case?.additionalInformation?.priority : alert?.priority"
    >
      <p class="dataTitle">Prioridad</p>
      <p class="dataInfo">
        {{ case ? case?.additionalInformation.priority : alert?.priority }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="case ? case?.additionalInformation?.code : alert?.code"
    >
      <p class="dataTitle">Código</p>
      <p class="dataInfo">
        {{ case ? case?.additionalInformation.code : alert?.code }}
      </p>
    </div>
    <!-- <div

    <div
      *ngIf="
        case.additionalInformation?.code == '04' ||
        case.additionalInformation?.code == '05'
      "
      class="divData"
    >
      <p class="dataTitle">Procede</p>
      <p class="dataInfo">
        {{ case.additionalInformation.proceed }}
      </p>
    </div>
    <div
      class="divData"
      *ngIf="alert?.status == 'refusedApproved' || alert?.status == 'proceed'"
    >
      <p class="dataTitle">Decisión</p>
      <p class="dataInfo">
        {{ statusAlert[alert?.status] }}
      </p>
    </div> -->
  </div>
</div>
